











import Vue from 'vue';
import CollegeLogo from './logos/CollegeLogo.vue';
import CollegeName from './logos/CollegeName.vue';
import CollegeNameWithLogo from './logos/CollegeNameWithLogo.vue';

const logos: { [name: string]: Vue.Component } = {
  collegeName: CollegeName,
  collegeLogo: CollegeLogo,
  CollegeNameWithLogo: CollegeNameWithLogo,
};

interface Data {
  logo: Vue.Component;
}

export default Vue.extend({
  props: {
    height: { type: Number, default: 32 },
    name: { type: String, default: 'collegeLogo' },
    width: { type: Number, default: 32 },
  },
  data(): Data {
    return { logo: logos[this.name] };
  },
});
